import { defaultLanguage, supportedLanguages } from 'cf-i18n/constants'
import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: supportedLanguages,
  defaultLocale: defaultLanguage,
  localePrefix: 'as-needed',
  localeDetection: false,
  localeCookie: false,
  alternateLinks: false,
})
